import { useState } from "react"

import ZoneStorageSorter2SelectLane from "./sorterTwo/sorter-2-select-lane";
import ZoneStorageSorter2Scanner from "./sorterTwo/sorter-2-scanner";
import ZoneStorageSorter2MegaOrder from "./sorterTwo/sorter-2-mega-order";

type zoneSorter1 = {
    warehouse: string,
    bay: string,
    resetFunc: () => void
}

const ZoneStorageSorter2 = ({ warehouse, bay, resetFunc }: zoneSorter1) => {
    const [lane, set_lane] = useState<string>("");
    const [additionalLanes, set_additionalLanes] = useState<string[]>([]);
    const [batch, set_batch] = useState<number>(0);
    const [date, set_date] = useState<string>("");

    return (
        <div style={{ height: "100%" }}>
            {lane === "" && <ZoneStorageSorter2SelectLane warehouse={warehouse} bay={bay} set_Lane={set_lane} set_additionalLanes={set_additionalLanes} set_Batch={set_batch} set_Date={set_date} goBack={resetFunc} />}
            {(lane !== "" && bay != "99") && <ZoneStorageSorter2Scanner warehouse={warehouse} bay={bay} lane={lane} additionalLanes={additionalLanes} batch={batch} date={date} resetFunc={resetFunc} setLane={set_lane} />}
            {(lane !== "" && bay == "99") && <ZoneStorageSorter2MegaOrder warehouse={warehouse} bay={bay} lane={lane} batch={batch} date={date} resetFunc={resetFunc} setLane={set_lane} />}
        </div>
    );

}

export default ZoneStorageSorter2